var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{attrs:{"data-column-id":"_id","data-identifier":"_id","data-visible":"false"}},[_vm._v("ID")])
}
var staticRenderFns = []

export { render, staticRenderFns }